'use client'

import { useEffect, useState } from 'react'

interface EnvironmentLabelProps {
  className?: string
}

export function EnvironmentLabel({ className = '' }: EnvironmentLabelProps) {
  const [environment, setEnvironment] = useState<'local' | 'staging' | 'production' | null>(null)

  useEffect(() => {
    const hostname = window.location.hostname
    
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('localhost:')) {
      setEnvironment('local')
    } else if (hostname === 'staging.airbills.co') {
      setEnvironment('staging')
    } else {
      setEnvironment('production')
    }
  }, [])

  // Don't render anything in production
  if (!environment || environment === 'production') {
    return null
  }

  const getEnvironmentConfig = () => {
    switch (environment) {
      case 'local':
        return {
          label: 'On Local',
          bgColor: 'bg-red-500',
          textColor: 'text-white',
          hoverColor: 'hover:bg-red-600'
        }
      case 'staging':
        return {
          label: 'On Staging',
          bgColor: 'bg-orange-500',
          textColor: 'text-white',
          hoverColor: 'hover:bg-orange-600'
        }
      default:
        return null
    }
  }

  const config = getEnvironmentConfig()
  if (!config) return null

  return (
    <div 
      className={`
        fixed bottom-4 left-4 z-50
        ${config.bgColor} ${config.textColor} ${config.hoverColor}
        px-3 py-1.5 rounded-md shadow-lg
        text-xs font-medium
        transition-all duration-200
        opacity-80 hover:opacity-100
        pointer-events-auto
        ${className}
      `}
      style={{ zIndex: 9999 }}
    >
      {config.label}
    </div>
  )
}
